module.exports = __webpack_public_path__ + "img/phone.544d314c.svg";